var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "form-wrapper" }, [
    _c(
      "div",
      { staticClass: "confirmation" },
      [
        _c("logo-header", {
          attrs: { title: "Verify Your Email", designVersion: 2 },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "body" }, [
          _c(
            "div",
            { staticClass: "spinner", class: { hidden: !_vm.isSubmitting } },
            [_c("i", { staticClass: "fa fa-spinner fa-pulse" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { class: { hidden: _vm.isSubmitting } },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "paragraph",
                {
                  attrs: {
                    id: "instruction",
                    type: "p",
                    variation: "large",
                    alignment: "center",
                  },
                },
                [
                  _vm._v(
                    "Please follow the instructions in the verification email to activate your account. Your first scan will start automatically after clicking the verification link."
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "button-wrapper" },
                [
                  !_vm.isSubmitting
                    ? _c("custom-button", {
                        attrs: {
                          text: "Resend Verification Link",
                          size: "button-large",
                        },
                        on: { click: _vm.resendLink },
                      })
                    : _c(
                        "button",
                        {
                          staticClass: "btn btn-primary hidden",
                          attrs: {
                            id: "mock-button-to-maintain-form-height",
                            isActive: false,
                          },
                        },
                        [_vm._v("Resend Verification Code")]
                      ),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.resentMsg,
                          expression: "resentMsg",
                        },
                      ],
                      staticClass: "label",
                    },
                    [_vm._v(_vm._s(_vm.resentMsg))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "paper-plane-icon-wrapper" }, [
      _c("img", {
        attrs: {
          id: "paper-plane-icon",
          src: "/assets/images/paper-plane.svg",
          alt: "paper-plane-icon",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }